import { GTM } from "../app/shared/constants/variables.constants";

export const commonSbEnv = {
  clientCode: 'SB',
  productCode: '',
  local: false,
  production: true,
  valentin: true,
  bogdan: false,
  moneydays: false,
  dan: false,
  hubix: false,
  client: {
    sb: true,
    cb: false,
    ib: false,
  },
  google_tagmanager_id: GTM.STIINTA_BANILOR,
  tosUrl: {
    policy: 'https://stiintabanilor.ro/politica-de-confidentialitate/',
    cookies: 'https://stiintabanilor.ro/politica-privind-fisierele-cookies/',
    protectiaDatelor: 'https://stiintabanilor.ro/politica-de-confidentialitate/',
  },
  favicon: 'assets/images/favicon-sb.ico',
  page: '',
  pageCode: '',
  meta: {
    siteTitle: 'Stiinta Banilor',
    siteDescription: '',
    ogSiteName: 'Stiinta Banilor 2024',
    ogUrl: '',
    ogImage: '',
    ogImageAlt: ''
  },
  landingPage: {
    BURSA_1: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa/',
    BURSA_2: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/',
    cursIINivel1: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa/',
    cursIINivel2: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa-nivelul-2/',
    cursIINivel3: 'https://stiintabanilor.ro/cursuri/curs-investitii-eficiente-pe-bursa-pentru-dividende/',
    imobiliare: 'https://stiintabanilor.ro/cursuri/curs-imobiliare/',
    imobiliareNivel2: 'https://stiintabanilor.ro/cursuri/curs-investitii-imobiliare-nivelul-2/',
    imobiliareApartamente: 'https://stiintabanilor.ro/cursuri/curs-investitii-imobiliare-apartamente/',
    incomeAccelerator: 'https://stiintabanilor.ro/cursuri/income-accelerator/',
    cpip: 'https://stiintabanilor.ro/cursuri/curs-practic-de-investitii-pasive/',
    cip: 'https://stiintabanilor.ro/cursuri/curs-de-investitii-pasive/',
    conferintaSb: 'https://stiintabanilor.ro/cursuri/conferinta-stiintabanilor/',
    conferintaSb2024: 'https://stiintabanilor.ro/cursuri/conferinta-stiintabanilor-2024/',
    sbP12: 'https://stiintabanilor.ro/cursuri/programul-online-de-12-saptamani-succes-in-finante-personale-si-investitii/?ref=3',
    moneySmart: 'https://stiintabanilor.ro/cursuri/moneysmart/',
    moneydays: 'https://stiintabanilor.ro/cursuri/moneydays-2022/',
    deNeinvins: 'https://stiintabanilor.ro/cursuri/de-neinvins/',
    primulPortofoliu: 'https://stiintabanilor.ro/cursuri/primul-portofoliu-pe-bursele-internationale/',
    rstCursBursa: 'https://razvanstan.ro/investitii-la-bursa/?ref=3',
  },
  product: {
    cursIINivel2: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=18475',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=18477',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=18479',
    },
    cursIINivel1: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=9501',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=9502',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=9503',
    },
    cursIINivel3: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=22867',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=22868',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=22869',
    },
    imobiliare: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=7075',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=16323',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=16324',
    },
    imobiliareNivel2: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=21361',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=21362',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=21363',
    },
    imobiliareApartamente: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=38153',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=38155',
    },
    incomeAccelerator: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=13718',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=13719',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=13720',
    },
    cpip: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=7572',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=7573',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=7574',
    },
    cip: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=34082',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=34084',
    },
    conferintaSb: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=31954',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=31954',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=31954',
    },
    conferintaSb2025: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=37472',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=37473',
    },
    moneySmart: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=10866',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=10867',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=10868',
    },
    moneydays: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=30571',
      gold: 'https://stiintabanilor.ro/cos/?add-to-cart=30572',
      vip: 'https://stiintabanilor.ro/cos/?add-to-cart=23234',
    },
    deNeinvins: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=7208',
    },
    primulPortofoliu: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=20143',
    },
    sbPachetIncepatori: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=15349',
    },
    sbPachetAvansati: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=15347',
    },
    sbPachetInvestitii: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=25446',
    },
    sbPachetToateCursurile: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=10214',
    },
    sbPachetEndlessPerfectSummer: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=29055',
    },
    sbPachetMinicursuri: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=30526',
    },
    sbP10: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=31166',
    },
    sbP12: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=34069',
    },
    sbPachetMentoring: {
      silver: 'https://stiintabanilor.ro/cos/?add-to-cart=25453',
    },
    cbPachetToateCursurile: {
      silver: '',
    },
    cbPachetInvestitii: {
      silver: '',
    },
    cbPachetInitiere: {
      silver: '',
    },
    cbPachetMentoring: {
      silver: '',
    },
    cbPachetBursa: {
      silver: '',
    },
    cbPachetImobiliare: {
      silver: '',
    },
    rstCursBursa: {
      silver: 'https://razvanstan.ro/investitii-la-bursa/?ref=3',
    },
  }
};
